module.exports = __webpack_public_path__ + "media/images/front/varieties/ORRI-c313683db75c7be8b4370fdb078c3a80.jpg";